<template>
  <div>
    <div class="comment-row">
      <div class="flex justify-between">
        <div class="flex items-center space-x-2 lg:space-x-0">
          <div class="comment-row__avatar">
            <div class="comment-row__avatar--placeholder">
              <BaseIcon name="person" color="primary-200" size="lg" />
            </div>
          </div>
          <div>
            <div class="comment-row__name">
              <span>{{ comment.name }}</span>
            </div>
            <div class="comment-row__date-score">
              <span>{{ comment.created_at }}</span>
            </div>
          </div>
        </div>
        <div>
          <BaseRatingStar
            :star="comment.score"
            size="md"
            :color="color"
            class="mx-auto lg:mt-2 lg:block hidden"
          />
        </div>
      </div>
      <div>
        <BaseTag v-if="comment.tag" color="transparent" custom-border="border border-primary-100" class="comment-row__container">
          <span class="text-label-text">{{ $t('common.labels.learned_lesson') }}:</span>
          <span class="comment-row__tag">{{ comment.tag }}</span>
        </BaseTag>
      </div>
      <div class="comment-row__comment">
        {{ comment.comment }}
      </div>
    </div>
    <BlockCommentRowResponse v-if="comment.response" :text="comment.response" :date="comment.created_at" class="mt-6 lg:mt-8" />
  </div>
</template>

<script>
import BaseRatingStar from '@design-system/base/rating/rating-star.vue'
import BlockCommentRowResponse from './comment-row-response'

export default {
  name: 'BlockCommentRow',
  components: {
    BlockCommentRowResponse,
    BaseRatingStar
  },
  inject: ['teacher'],
  props: {
    comment: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    color () {
      return this.teacher.designColor ? this.teacher.designColor : 'primary'
    }
  },
  methods: {
    nahansdf (sfsf) {
      console.log(sfsf)
    }
  }
}
</script>

<style scoped lang="scss">
.comment-row {
  @apply pt-6;
  &__avatar {
    @apply w-[56px] lg:w-[72px];
    &--placeholder {
      @apply flex items-center justify-center bg-primary-50 border border-primary-100
      w-[56px] h-[56px] lg:w-12 lg:h-12 rounded-full;
    }
  }
  &__name {
    @apply flex justify-between text__caption-xs--bold lg:text__body-2-md--bold text-body-2;
  }
  &__date-score {
    @apply flex justify-between;
    span:first-of-type {
      @apply text__caption-1-xs--regular lg:text__body-3-md--regular text-label-text;
    }
    span:last-of-type {
      @apply text__caption-xs--regular lg:text__body-3-md--regular text-label-text;
    }
  }
  &__comment {
    @apply text__body-2-xs--regular text__body-2-md--regular text-body-2 mt-4;
  }
  &__container {
    @apply mt-4 space-x-2 px-2 lg:px-3;
  }
  &__tag {
    @apply text-title py-1 text__caption-1-xs--regular  lg:text__caption-xs--regular lg:py-1;
  }
}
</style>
